import { UseSuspenseQueryOptions } from "@tanstack/react-query";

import { FetchAllTagsResponse } from "@seneca/tags-service-types";

import { getClient } from "services";

export function getTagsQueryOptions({
  region,
  includeHidden = false,
  includeNonCourseFilters
}: {
  region?: string;
  includeHidden?: boolean;
  includeNonCourseFilters?: boolean;
} = {}): UseSuspenseQueryOptions<FetchAllTagsResponse> {
  return {
    queryFn: () => fetchAllTags({ region, includeNonCourseFilters }),
    queryKey: [
      "tags-service",
      "fetchAll",
      region,
      includeNonCourseFilters,
      includeHidden
    ],
    retryOnMount: false,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
    select: data =>
      includeHidden
        ? data
        : { ...data, tags: data.tags.filter(tag => !tag.details?.hidden) }
  };
}

async function fetchAllTags({
  region,
  includeNonCourseFilters
}: { region?: string; includeNonCourseFilters?: boolean } = {}) {
  return (await getClient("tagService").fetchAll({
    region,
    includeNonCourseFilters
  })) as FetchAllTagsResponse;
}
